// @flow

function addTouchClass(el: HTMLElement, ...classes: string[]) {
  const add = () => {
    classes.map(c => el.classList.add(c))
    el.removeEventListener('touchstart', add)
  }

  el.addEventListener('touchstart', add)
}

export { addTouchClass }



// WEBPACK FOOTER //
// ./src/lib/add-touch-class.js